module.exports = __webpack_public_path__ + "img/HorizontalEdgesMask.56841c33.svg";